import { render } from "./PrincipalSection.vue?vue&type=template&id=84443a62&scoped=true"
import script from "./PrincipalSection.vue?vue&type=script&lang=js"
export * from "./PrincipalSection.vue?vue&type=script&lang=js"

import "./PrincipalSection.vue?vue&type=style&index=0&id=84443a62&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84443a62"]])

export default __exports__